module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Media/Next-e710c0138587c5110fa17219a69ebc9783aed68d59a6df1da004bb869e29af1c.svg";